import { render } from "./CIS-Healthcare-Graphic-Data.vue?vue&type=template&id=6aa18d2e&scoped=true"
import script from "./CIS-Healthcare-Graphic-Data.vue?vue&type=script&lang=js"
export * from "./CIS-Healthcare-Graphic-Data.vue?vue&type=script&lang=js"

import "./CIS-Healthcare-Graphic-Data.vue?vue&type=style&index=0&id=6aa18d2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa18d2e"]])

export default __exports__